// Turns a literal `<br>` in an answer into a real line break, and nothing else.
//
// Models write `<br>` inside Markdown table cells, where Markdown has no line-break syntax of its
// own. The chat renders Markdown without raw HTML, so that tag reached the person as the literal
// text "<br>". This converts exactly one tag, in its three spellings and with no attributes, into
// Markdown's own `break` node; every other tag is still escaped. It is the one exception to raw HTML
// staying text (@adr SPARK-0063-markdown-renders-raw-html-escaped-with-one-break-exception@1): only AgentMarkdown runs this
// plugin, and the Studio notebook PDF (`notebookPdfBlocks`) applies the same `isBareBr` rule.

interface MdNode {
  type: string;
  value?: string;
  children?: MdNode[];
}

const BR = /^<br\s*\/?>$/i;

/** Whether raw HTML is a bare `<br>`: `<br>`, `<br/>` or `<br />` once trimmed, in any case, with no attribute. */
export function isBareBr(html: string): boolean {
  return BR.test(html.trim());
}

function walk(node: MdNode): void {
  if (!node.children) return;
  node.children = node.children.map((child) => (child.type === "html" && isBareBr(child.value ?? "") ? { type: "break" } : child));
  for (const child of node.children) walk(child);
}

/** remark plugin: `<br>` / `<br/>` / `<br />` become line breaks, inside table cells included. */
export function remarkHtmlBreaks() {
  return (tree: MdNode) => walk(tree);
}
